import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import accountActivityReportTemplate from './accountActivityReport.template.html';

export default angular
  .module('books.ui.accountActivityReport', [csmCommonWeb, booksService])
  .directive('accountActivityReport', accountActivityReportDirective).name;

/* @ngInject */
function accountActivityReportDirective(BooksSvc, $q, BusyScreen) {
  /* accountNumberHide
    /* Optional. Passthrough from the accountSelector directive. 
    /* Hides the account number input field when true. 
    /* 
    /* itemHide
    /* Optional. Hides the item selection when true.
    /*
    /* individualHide
    /* Optional. Hides the individual selection when true.
    /*
    /* action
    /* Passthrough from the reportTemplate directive. This is the
     * action (aspx page to be opened) on submit.
    /* 
    /* selectorLabel
    /* Label for the input field.
    */
  return {
    template: accountActivityReportTemplate,
    scope: {
      accountNumberHide: '=',
      itemHide: '=',
      individualHide: '=',
      action: '=',
      selectorLabel: '@'
    },
    link: function ($scope, element, attr) {
      BusyScreen.setBusy(true);

      /*----------------------*/
      /* Sets default values. */
      /*----------------------*/
      $scope.req = { reportFormat: 'PDF' };

      /*--------------------------------------------*/
      /* Works with the CSMValidator to make sure   */
      /* the account and date fields are populated. */
      /*--------------------------------------------*/
      $scope.valOption = {};
      $scope.validateInput = function () {
        return $scope.valOption.validate();
      };

      /***********************************************************************
       * checkEntity */
      /**
       * Blur handler to verify that an entity has been selected for the Individual
       * typeahead indicated by the model having a numeric value. If not, clear the
       * model and reset the input text to All Individuals.
       ***********************************************************************/
      $scope.checkEntity = function (event) {
        if (isNaN(Number($scope.req.entityID))) {
          $scope.req.entityID = 0;
          angular.element(event.target).val('All Individuals');
        }
      };

      /***********************************************************************
       * checkItem */
      /**
       * Blur handler to verify that an item has been selected for the typeahead
       * indicated by the model having a numeric value. If not, clear the model
       * reset the input text.
       ***********************************************************************/
      $scope.checkItem = function (event) {
        if (isNaN(Number($scope.req.itemID))) {
          $scope.req.itemID = 0;
          angular.element(event.target).val('All Items');
        }
      };

      /*****************************************************************************
       * getEntityNames */
      /**
       * Dataprovider source for the individual name input. Returns a promise for the
       * type ahead directive to wait for.
       *
       * @param  text  Current type ahead text
       * @return       Promise object for server response
       *****************************************************************************/
      $scope.getEntityNames = function (text) {
        var defer = $q.defer();
        BooksSvc.findEntities(text, 0).then(function (resp) {
          defer.resolve(($scope.names = resp.data));
        });
        return defer.promise;
      };

      /*****************************************************************************
       * formatNames */
      /**
       * Returns the corresponding individuals from getEntityNames() to display in the
       * typeahead.
       * When no match is found will retun "All Individuals".
       *
       * @param  model  Current model value
       * @return        Corresponding individual.
       *****************************************************************************/
      $scope.formatNames = function (model) {
        if ($scope.names)
          for (var i = 0; i < $scope.names.length; i++) {
            if ($scope.names[i].id == model) {
              return $scope.names[i].fullName;
            }
          }
        return 'All Individuals';
      };

      /*****************************************************************************
       * getItemsList */
      /**
       * Gets the list of items and returns them in in alphabetical order to a promise
       * for the item typeahead.
       *
       * @param  text  Current type ahead text
       * @return       Promise object for server response
       *****************************************************************************/
      $scope.getItemsList = function (text) {
        var defer = $q.defer();
        BooksSvc.getProductList(true, false, false, false).then(function (
          resp
        ) {
          $scope.items = resp.data
            .sort(function (a, b) {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            })
            .filter(function (i) {
              return i.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
            });
          defer.resolve($scope.items);
        });
        return defer.promise;
      };

      /*****************************************************************************
       * formatItem */
      /**
       * Returns the corresponding items from the itemsList() to display in the
       * typeahead.
       * When no match is found will return "All Items".
       *
       * @param  model  Current model value
       * @return        Corresponding item.
       *****************************************************************************/
      $scope.formatItem = function (model) {
        if ($scope.items)
          for (var i = 0; i < $scope.items.length; i++) {
            if ($scope.items[i].id == model) {
              return $scope.items[i].name;
            }
          }
        return 'All Items';
      };

      /*--------------*/
      /* Get services */
      /*--------------*/
      BooksSvc.getPermittedAccounts().then(function (resp) {
        $scope.accounts = resp.data;

        BooksSvc.getOrganization().then(function (resp) {
          $scope.org = resp.data;
          BusyScreen.setBusy(false);
        });
      });
    }
  };
}
